import { AccordionSummary, styled } from "@mui/material"
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const StyledAccordionSummary = styled(AccordionSummary)({
  fontSize: '1.1rem',
  fontWeight: 700,
  background: '#d5eaff',
  color: '#000',
  height: '50px',
  minHeight: '50px !important',
  margin: 0,
  padding: 0,
  '&.Mui-expanded': {
    minHeight: '50px !important',
    height: '50px',
    margin: 0,
  },
  '& .MuiAccordionSummary-content': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: 0,
    padding: '0 16px', // Add some padding for content readability
    '&.Mui-expanded': {
      margin: 0,
    },
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    color: '#000',
    marginRight: '10px'
  },
})

interface OverwatchAccordionSummaryProps {
  children: React.ReactNode;
  expandIcon?: JSX.Element
}
const OverwatchAccordionSummary: React.FC<OverwatchAccordionSummaryProps> = ({ children, expandIcon }) => {
  return (
    <StyledAccordionSummary expandIcon={expandIcon ?? <ExpandMoreIcon />} >
      {children}
    </StyledAccordionSummary>
  )
}

export default OverwatchAccordionSummary
